import {Card} from '@resurs/tron-react';
import {FormattedMessage} from 'react-intl';
import '../../styles/general-styles.css';

const Timeout = () => (
  <div className="container container--fixed pt-50">
    <Card className="h-100 border-0 mx-auto max-w-800 rounded-0 align-items-center">
      <h4 className="header-font ml-3">
        <FormattedMessage
          id="TimeoutContainer.header"
          defaultMessage="Timeout"
        />
      </h4>
      <span className="ml-3">
        <FormattedMessage
          id="TimeoutContainer.info"
          defaultMessage="Kontakt Resurs"
        />
      </span>
    </Card>
  </div>
);

export default Timeout;
